import { CommentBox } from "./CommentBox";
import { CommentViewContext } from "./interface";
import { sortCommentsAscending } from "./sortComments";
import { useComments } from "./useComments";

export interface CommentThreadProps {
  id: string;
  activeContext: CommentViewContext;
}

/**
 * Display a single comment and its nested replies in a threaded view.
 *
 * @param props - Component props.
 * @param props.id - Comment id to display.
 * @param props.activeContext - Active comment view context.
 */
export const CommentThread = ({
  id,
  activeContext,
}: CommentThreadProps): React.ReactElement | null => {
  // Get contexts
  const { comments, commentPanelStatus, setCommentPanelStatus, readComment } =
    useComments(activeContext);
  const thisComment = readComment(id);

  return !thisComment ||
    ((!commentPanelStatus || !setCommentPanelStatus) && activeContext !== "Toc") ? null : (
    <>
      <CommentBox
        commentId={id}
        activeContext={activeContext}
        disabled={activeContext === "Toc" || comments.some((c) => c.parentId === id)}
      />
      <div className="comment-reply-holder">
        {comments
          .filter((c) => c.parentId === id)
          .sort(sortCommentsAscending)
          .map((c) => (
            <div
              key={c.id}
              className="comment-reply"
            >
              <CommentThread
                id={c.id}
                activeContext={activeContext}
              />
            </div>
          ))}
      </div>
    </>
  );
};

CommentThread.displayName = "CommentThread";
